import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import {
  CouponDetailScreen,
  CouponScreen,
  EditProfileScreen,
  HomeScreen,
  MemberQrScreen,
  PointHistoryScreen,
  PromotionDetailScreen,
  PromotionScreen,
  ProfileScreen,
  RedeemScreen,
  ReferralScreen,
  VoucherDetailScreen,
  VoucherScreen,
  MemberScreen,
} from "screens"
import { translate } from "i18n"
import { Header } from "components"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import { UploadReceiptScreen } from "screens/Application/UploadReceipt"
import { NotificationScreen } from "screens/Application/Notification"
import { FeedbackScreen } from "screens/Application/Feedback"
import { RewardsScreen } from "screens/Application/Rewards"
import { RewardDetailScreen } from "screens/Application/RewardsDetail"
import { MemberUpgrade } from "screens/Application/MemberUpgrade"
import { MemberShipScreen } from "screens/Application/MemberShip"
import { RewardGift } from "screens/Application/RewardGift"
import { StampsDetailScreen } from "screens/Application/StampsDetails"
import { StampsScreen } from "screens/Application/Stamps"

export type HomeParamList = {
  home: undefined
  memberQr: undefined
  editProfile: undefined
  referral: undefined
  redeem: undefined
  promotion: undefined
  promotionDetail: undefined
  pointHistory: undefined
  profile: undefined
  voucher: undefined
  voucherDetail: undefined
  coupon: undefined
  couponDetail: undefined
  uploadReceipt: undefined
  notification: undefined
  feedback: undefined
  member: undefined
  memberShip: undefined
  rewards: undefined
  rewardDetail: undefined
  memberUpgrade: undefined
  rewardGift: undefined
  promotionHome: undefined
  stampsDetails: undefined
  stamp: undefined
}
const Stack = createStackNavigator<HomeParamList>()

export const HomeStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        header: (props) => {
          return <Header {...props} />
        },
        headerBackImage: () => <MaterialIcons name="chevron-left" color="white" size={42} />,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerStyle: {
          backgroundColor: "transparent",
          borderBottomWidth: 0,
        },
        headerTintColor: "white",
        cardStyle: { flex: 1, borderWidth: 0 },
      }}
    >
      <Stack.Screen
        name="home"
        component={HomeScreen}
        options={{
          headerTitle: translate("homeScreen.title"),
          headerShown: true,
        }}
      />
      <Stack.Screen
        name="memberQr"
        component={MemberQrScreen}
        options={{
          headerTitle: translate("memberQrScreen.title"),
        }}
      />
      <Stack.Screen
        name="editProfile"
        component={EditProfileScreen}
        options={{
          headerTitle: translate("editProfileScreen.title"),
        }}
      />
      <Stack.Screen
        name="referral"
        component={ReferralScreen}
        options={{
          headerTitle: translate("referralScreen.title"),
        }}
      />
      <Stack.Screen
        name="redeem"
        component={RedeemScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen name="promotion" component={PromotionScreen} />
      <Stack.Screen
        name="promotionDetail"
        component={PromotionDetailScreen}
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="pointHistory"
        component={PointHistoryScreen}
        options={{
          headerTitle: translate("pointHistoryScreen.title"),
        }}
      />
      <Stack.Screen
        name="profile"
        component={ProfileScreen}
        options={{
          headerTitle: translate("profileScreen.title"),
        }}
      />
      <Stack.Screen
        name="voucher"
        component={VoucherScreen}
        options={{
          headerTitle: translate("voucherScreen.title"),
        }}
      />
      <Stack.Screen name="voucherDetail" component={VoucherDetailScreen} />
      <Stack.Screen name="coupon" component={CouponScreen} />
      <Stack.Screen name="uploadReceipt" component={UploadReceiptScreen} />
      <Stack.Screen name="couponDetail" component={CouponDetailScreen} />
      <Stack.Screen name="notification" component={NotificationScreen} />
      <Stack.Screen name="feedback" component={FeedbackScreen} />
      <Stack.Screen name="rewards" component={RewardsScreen} />
      <Stack.Screen name="rewardDetail" component={RewardDetailScreen} />
      <Stack.Screen
        name="member"
        component={MemberScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="memberUpgrade"
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
        component={MemberUpgrade}
      />
      <Stack.Screen
        name="memberShip"
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
        component={MemberShipScreen}
      />
      <Stack.Screen
        name="rewardGift"
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
        component={RewardGift}
      />
      <Stack.Screen name="promotionHome" component={PromotionScreen} />
      <Stack.Screen
        name="stamp"
        component={StampsScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
      <Stack.Screen
        name="stampsDetails"
        component={StampsDetailScreen}
        options={{
          headerTitle: translate("redeemScreen.title"),
        }}
      />
    </Stack.Navigator>
  )
}
